class FuneralQuote {

    form;

    constructor() {
        this.form = document.querySelector('#funeral-quote-form');

        if (this.form) {
            this.form.addEventListener('submit', () => false);
            this.form.addEventListener('change', this.calculateTotalCosts.bind(this));
            this.calculateTotalCosts();
        }
    }

    calculateTotalCosts() {
        const cateringCostsElement = document.querySelector('#cateringCosts');
        const cateringCostsPerPerson = +cateringCostsElement.getAttribute('data-catering-costs-per-person');
        cateringCostsElement.value = +document.querySelector('#cateringNumberOfPeople').value * cateringCostsPerPerson;

        let totalCosts = 0;
        const selectors = [
            'input[type="hidden"]:not([disabled])',
            'input[type="checkbox"]:checked:not([disabled])',
            'input[type="radio"]:checked:not([disabled])',
            'input[type="number"]:not([disabled]):not([data-ignored])',
        ];
        this.form.querySelectorAll(selectors.join(',')).forEach(formElement => {
            const itemCosts = +(formElement.value || formElement.min);
            if (isNaN(itemCosts)) {
                return;
            }
            totalCosts += itemCosts;
        });

        this.form.querySelector('#totalCosts').value = totalCosts.toLocaleString('nl-NL', { maximumFractionDigits: 2 });
    }

}
